import { useDispatch } from "react-redux";
import { useGetDeviceTimeMarksByHourQuery } from "../../../api/rtk/weatherStations/slices/weatherStationsApiSlice";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { setTimeMark } from "../../../stateManagement/reducers/services/weatherStations/WeatherStationsSlice";
import { formatDateToISO8601, formatDateToLocalFormatHHmm } from "../../../shared/format/date";
import { useHorizontalWheelScroll } from "../../../shared/hooks/useHorizontalWheelScroll";
import { useEffect } from "react";
import SmallLoader from "../../loaders/SmallLoader";

export function TimeMarkList() {
    const dispatch = useDispatch()
    const { date, deviceId, hour, timeMark } = useAppSelector(state => state.weatherStationsService);
    const { data: timeMarks, isFetching } = useGetDeviceTimeMarksByHourQuery({ date: formatDateToISO8601(date), deviceId, hour, timezone: "Asia/Tomsk" }, { skip: deviceId == null || hour == null || date == null })

    const onWheel = useHorizontalWheelScroll({ speed: 0.65 });

    useEffect(() => {
        if (Array.isArray(timeMarks) && timeMarks.length > 0) {
            dispatch(setTimeMark(timeMarks[0]))
        }
        return () => {
            dispatch(setTimeMark(undefined))
        }
    }, [timeMarks])

    return (
        <div className="time-mark-list-container">
            {isFetching
                ?
                <SmallLoader iconColor="black" text="Загрузка временных меток..." className="time-mark-list-loader" />
                :
                (Array.isArray(timeMarks) && timeMarks.length > 0
                    ?
                    <div className="time-mark-list" onWheel={onWheel}>
                        <span>Время:</span>
                        {timeMarks.map((tM) => {
                            return (
                                <div className={"time-mark-list-item" + (timeMark === tM ? ' active' : '')} onClick={() => dispatch(setTimeMark(tM))}>
                                    {formatDateToLocalFormatHHmm(tM, "Asia/Tomsk")}
                                </div>
                            )
                        })}
                    </div>
                    :
                    <p className="no-time-marks">Нет временных меток</p>
                )
            }
        </div>
    )
}
